import React, { useState, useEffect, useRef, useCallback } from 'react'

// Deps
// import compareAsc from 'date-fns/compareAsc'

// Functions
import formatDate from 'functions/format-date'

// Utils
import { openModal } from 'utils/modals';

// Partials
import { Table, TR, TD } from 'views/shared/partials/table'
import Loader from 'views/shared/partials/loader'
import Btn from 'views/shared/partials/btn'
import Dropdown from 'views/shared/partials/dropdown'
import Link from 'views/shared/partials/link'
import { InputForm, FormInput } from 'views/shared/partials/forms'

// Services
import companyServices from 'services/company'

const ClientList = (props) => {
	const query = props.query;
	const plain = props.plain;

	const searchForm = useRef();

	const [data, setData] = useState(false);

	const getData = useCallback(() => {
		setData(false);

		companyServices.listClients(query).then((payload) => {
			setData(payload);
		}).catch((error) => {
		});
	}, [query]);

	const deleteClient = (client) => {
		openModal(
			'confirm',
			{
				message: '<strong>' + ((client.invoice_type === 2 && client.company_name) ? client.company_name : (client.executive_name + ' ' + client.executive_surname)) + '</strong> isimli kullanıcıyı silmek istediğinizden emin misiniz?',
				onConfirm: () => {
					companyServices.deleteClient(client.client_code).then(() => {
						getData();
					}).catch(() => {})
				}
			}
		)
	}

	useEffect(() => {
		getData();	
	}, [query, getData])

	return (
		<section className={'portlet clientlist ' + (props.className ? props.className : '')}>
			<div className="portlet-header">
				<strong className="portlet-title">{props.groupID ? 'Gruba Ait Kullanıcılar' : props.title}</strong>

				<div className="header-controls">
					<Btn white small wide icon="plus" onClick={() => { openModal('client', { onSuccess: getData }); }}>Yeni Müşteri Oluştur</Btn>
				</div>
			</div>

			{!plain &&
				<InputForm
					ignoreEmpty
					className="portlet-filters"
					ref={searchForm}
					onSubmit={props.onSearch}>
					<div className="filters-searchwrap">
						<FormInput
							className="lower"
							type="text"
							name="search_value"
							value={query.search_value}
							//onChange={(val) => { setFilters({...filters, search_value: val}) }}
							placeholder="Kullanıcı Adı, Kullanıcı Kodu vs...">
						</FormInput>
						<button
							type="submit"
							className="searchwrap-submit">
							<i className="icon-search"></i> ara
						</button>
					</div>
				</InputForm>
			}
			<div className="portlet-section bottom loader-container">
				<Loader loading={!data} />

				{data &&
					<Table 
						emptyMessage="Aradığınız kriterlerde grup bulunmuyor."
						className="list-table"
						pagination={!plain ? data.pagination : undefined}
						onPaginate={(page) => { props.onPaginate(page); }}
						heading={
							<React.Fragment>
								<th>Müşteri Adı / Kodu</th>
								<th>Vergi Bilgileri</th>
								<th>Oluşturulma Tarihi</th>
								<th>Aktif Bekleyen Talepler</th>
								<th>Tamamlanan Talepler</th>
								<th></th>
							</React.Fragment>
						}>
						
						{data.clients.map((client, nth) => (
							<TR key={nth} /*mobileTitle={nth + 1 + '. Talep'}*/>
								<TD className="mobile-full">
									<p>
										<Link href="clientDetail" params={{id: client.client_code}}>
											{client.invoice_type === 2 &&
												<strong>
													{client.company_name ? client.company_name : (client.executive_name + ' ' + client.executive_surname)}
												</strong>
											}
											{client.invoice_type === 1 &&
												<strong>
													{client.executive_name} {client.executive_surname}
												</strong>
											}
										</Link>
									</p>
									<p className="table-subtitle">
										{client.client_code}
									</p>
									<p>
										{client.invoice_type === 1 ?
											<label className="label dark">
												Bireysel
											</label>
											:
											<label className="label">
												Kurumsal
											</label>
										}
										{client.client_code === 'anonim' &&
											<label className="label error">
												Anonim Müşteri
											</label>
										}
									</p>
								</TD>
								<TD>
									{(client.invoice_type === 1 && client.identity_number) &&
										<p className="table-minidata">
											<strong>TC Kimlik No</strong>
											{client.identity_number}
										</p>
									}
									{(client.invoice_type === 2 && client.tax_office && client.tax_number) &&
										<p className="table-minidata">
											<strong>{client.tax_office} V.D.</strong>
											{client.tax_number}
										</p>
									}
								</TD>
								<TD mobileTitle="Oluşturulma Tarihi" className={(!(client.invoice_type === 1 && client.identity_number) && !(client.invoice_type === 2 && client.tax_office && client.tax_number)) ? 'mobile-full' : ''}>
									<p>{formatDate(client.created_at, 'd MMMM yyyy')}</p>
									<p className="table-subtitle">{formatDate(client.created_at, 'HH:mm')}</p>
								</TD>
								<TD mobileTitle="Aktif Siparişler">
									{client.order_count_active}
								</TD>
								<TD mobileTitle="Tamamlanan Siparişler">
									{client.order_count_done}
								</TD>
								<TD className="controls">
									<Dropdown
										text="İşlemler"
										icon="list">
										<Link
											href="clientDetail"
											params={{ id: client.client_code }}>
											Detaya Git
										</Link>
										
										<button
											className="error"
											onClick={() => { deleteClient(client) }}>
											Müşteriyi Sil
										</button>
									</Dropdown>
								</TD>
							</TR>
						))}
					</Table>
				}
			</div>
		</section>
	)
}

ClientList.defaultProps = {
	query: {},
	title: 'Müşteriler',
	groupID: false,
	onPaginate: () => {},
	onSearch: () => {},
}


export default ClientList;